module.exports = function getResource(label, vars = []) {
    let resources = {
        goToBasket: 'Ouvrir le panier',
        item: 'article',
        items: 'articles'
    };
    return resources[label];
};
